import {all, call, fork, put, takeEvery} from "redux-saga/effects";
import {fetchCategorySuccess, fetchCategoryError, addCategorySuccess, addCategoryError, updateCategorySuccess, updateCategoryError} from '../actions/Category';
import { getDocs, addDoc, updateDoc } from 'firebase/services/category';
import {FETCH_CATEGORY, ADD_CATEGORY, UPDATE_CATEGORY} from 'constants/ActionTypes';

function* fetchCategoryRequest() {
  try {
    const fetchedCategoryList = yield call(getDocs);
    yield put(fetchCategorySuccess(fetchedCategoryList));
  } catch (error) {
    console.log(error);
    yield put(fetchCategoryError(error));
  }
}

function* addCategoryRequest({ payload: { params } }) {
  try {
    const requests = params.map(param => call(addDoc, {data: param}));
    const result = yield all(requests);
    yield put(addCategorySuccess(result));
  } catch (error) {
    console.log(error);
    yield put(addCategoryError(error));
  }
}

function* updateCategoryRequest({ params }) {
  try {
    const requests = params.map(param => call(updateDoc, {key: param.key, data: param}));
    const result = yield all(requests);
    yield put(updateCategorySuccess(result));
  } catch (error) {
    console.log(error);
    yield put(updateCategoryError(error));
  }
}

export function* fetchCategory() {
  yield takeEvery(FETCH_CATEGORY, fetchCategoryRequest);
}

export function* addCategory() {
  yield takeEvery(ADD_CATEGORY, addCategoryRequest);
}

export function* updateCategory() {
  yield takeEvery(UPDATE_CATEGORY, updateCategoryRequest);
}

export default function* rootSaga() {
  yield all([fork(fetchCategory), fork(addCategory), fork(updateCategory)]);
}
